import type { z } from "zod";
import type { Discount } from "../discount.types";
import type { discountSchema } from "../schemas/discount.schema";
import { discountResponseSchema } from "../schemas/discount.schema";

export function parseDiscount(raw: z.infer<typeof discountSchema>): Discount {
    return raw;
}

export function parseDiscountResponse(raw: unknown): Discount | undefined {
    const result = discountResponseSchema.safeParse(raw);
    if (!result.success) return undefined;
    const first = result.data.DiscountCodes.docs[0];
    return first ? parseDiscount(first) : undefined;
}
